import script from "./collapse.vue?vue&type=script&setup=true&lang=js"
export * from "./collapse.vue?vue&type=script&setup=true&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=57063ca2&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57063ca2"]])

export default __exports__